import { MODULE_ROUTES } from './routes.const';

type PlanningPages =
  | 'root'
  | 'calendar'
  | 'profiles'
  | 'profileDetails'
  | 'viewDetails'
  | 'attendees';

export const PLANNING_ROUTES: Record<PlanningPages, string> = {
  root: `${MODULE_ROUTES.planning}`,
  calendar: `${MODULE_ROUTES.planning}/calendar`,
  profiles: `${MODULE_ROUTES.planning}/profiles`,
  profileDetails: `${MODULE_ROUTES.planning}/profile-details`,
  viewDetails: `${MODULE_ROUTES.planning}/view-details`,
  attendees: `${MODULE_ROUTES.planning}/attendees`,
};
